export function barload(ativaNaPagina){

    let vblpace  = $('div.pace');
    
    if(ativaNaPagina == true ) {
        Pace.restart;
    }else{
        Pace.stop;
        Pace.options.ajax = false;
    }
}

export function exibirImagemLoading(varExibirImagemLoading , ativaNaPagina){

    let disLoad  = $('.page-loading');
    
    if(varExibirImagemLoading && ativaNaPagina ){
        disLoad.addClass("loadIn");
    }else{
        disLoad.removeClass("loadIn");
    }
}